import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createProductionPreset } from "../../helpers/http_production_presets_requests";

export default function ProductionPresetNew() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const formFieldList = [
        {
            title: "Cadastro de Preset",
            fields: [
                { name: "name", label: "Nome", type: "text", required: true },
                { name: "position", label: "Ordem", type: "number", required: true },
                { name: "prod_steps_json", label: "Passos de Produção", type: "steps", fullWidth: true },
            ],
        },
    ];

    const handleSubmit = (data) => {
        createProductionPreset(
            {
                name: data.name,
                position: Number(data.position) || 0,
                prod_steps_json: data.prod_steps_json || [],
            },
            () => {
                queryClient.invalidateQueries({ queryKey: ["getProductionPresets"] });
                navigate("/configuracao-presets");
            }
        );
    };

    return (
        <DynamicFormPage
            title="Presets - Cadastro"
            onSubmit={handleSubmit}
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
        />
    );
}
